import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { OrganigramPermissionsService } from '../../services/organigram-permissions.service';
import { can } from '../../mona-app/workflow-graph/logic/organigram-permission';

// The legacy workflow-builder page edits structure, workflows and organization settings with no role
// checks of its own, so only someone holding every organigram permission may open it. Everyone else
// is sent to /organigram, where each control follows their role.
@Injectable({ providedIn: 'root' })
export class LegacyOrganigramGuard implements CanActivate {
  constructor(private permissions: OrganigramPermissionsService, private router: Router) {}

  async canActivate(): Promise<boolean | UrlTree> {
    await this.permissions.settled();
    return can(this.permissions.current, 'organigram.admin') ? true : this.router.parseUrl('/organigram');
  }
}
